<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="toc"><span class="epub-b">CONTENTS</span></p>
<p class="toc"><span href="#/xhtml/title#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/illustration#ill">List of Illustrations</a></p>
<p class="toc-bot"><a href="#/xhtml/map#map">Maps</a></p>
<p class="toc"><a href="#/xhtml/intro#int">Introduction</a></p>
<p class="toc"><a href="#/xhtml/part1#pt1">One: Natural Nile: Beasts and beginnings</a></p>
<p class="toc"><span href="#/xhtml/part2#pt2" title="Link target outside of Sample">Two: Ancient Nile: Famine, pestilence and a severed penis</span></p>
<p class="toc"><span href="#/xhtml/part3#pt3" title="Link target outside of Sample">Three: River of the Believers: Madness and mystics</span></p>
<p class="toc"><span href="#/xhtml/part4#pt4" title="Link target outside of Sample">Four: The Nile Extended: Raw steak and Napoleon</span></p>
<p class="toc"><span href="#/xhtml/part5#pt5" title="Link target outside of Sample">Five: The Nile Damned: Elephants, exploration and Agatha Christie’s trunk</span></p>
<p class="toc"><span href="#/xhtml/part6#pt6" title="Link target outside of Sample">Six: Blood on the Nile: From assassination to revolution</span></p>
<p class="toc-bot"><span href="#/xhtml/epilogue#ep" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/photo1#photo1" title="Link target outside of Sample">Photographs</span></p>
<p class="toc"><span href="#/xhtml/bib#bib" title="Link target outside of Sample">A Very Select Bibliography</span></p>
<p class="toc"><span href="#/xhtml/ack#ack" title="Link target outside of Sample">Acknowledgements</span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample">Index</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Robert Twigger</span></p>
<p class="toc"><span href="#/xhtml/copyright#crp" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?54faaa75